import { ReactNode, useState } from 'react';

import { Box } from 'components/Box';

import { StyledCloseButton, StyledContainer } from './TooltipStandalone.styled';

type Props = {
  children: ReactNode;
  className?: string;
  arrowLeft?: boolean;
};

export function TooltipStandalone({ arrowLeft, children, className }: Props) {
  const [showTooltip, setShowTooltip] = useState(true);

  if (!showTooltip) return null;

  return (
    <StyledContainer className={className} $left={arrowLeft}>
      <Box position="relative" p="30px 20px 20px">
        <StyledCloseButton
          onClick={() => setShowTooltip(false)}
          data-qa-id="close-modal-button"
          data-modal-focus="false"
        />
        {children}
      </Box>
    </StyledContainer>
  );
}
